import { render } from "./opdTeam.vue?vue&type=template&id=c645cbb6&scoped=true"
import script from "./opdTeam.vue?vue&type=script&lang=js"
export * from "./opdTeam.vue?vue&type=script&lang=js"

import "./opdTeam.vue?vue&type=style&index=0&id=c645cbb6&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c645cbb6"]])

export default __exports__